<template>
  <div>
    <form @submit.prevent="createUnlistedEmployee()">
      <h5 class="title is-5" v-if="isFlights || isTrains || isCars">
        <template v-if="isFlights || isTrains">
          {{ $t("ReservationForm.addAPassenger") }}
        </template>
        <template v-else-if="isCars">
          {{ $t("CarReservationForm.addUnlistedDriver") }}
        </template>
      </h5>
      <br v-if="isFlights || isTrains || isCars" />
      <div class="control mb-5">
        <input
          class="input"
          name="firstName"
          id="firstName"
          v-model="firstName"
          required
          type="text"
          :placeholder="$t('ReservationForm.firstname')"
        />
      </div>

      <div class="control mb-5">
        <input
          class="input"
          name="lastName"
          id="lastName"
          v-model="lastName"
          required
          type="text"
          :placeholder="$t('ReservationForm.lastname')"
        />
      </div>

      <div class="control">
        <input
          class="input"
          v-model="emailAddress"
          required
          autocomplete="email"
          name="emailAddress"
          id="emailAddress"
          type="email"
          :placeholder="$t('ReservationForm.emailAddress')"
        />
      </div>
      <div class="is-justify-content-right is-flex">
        <button class="c-button c-button--secondary c-button--small mt-4">
          <span class="icon is-small">
            <i class="fas fa-plus"></i>
          </span>
          <span> {{ $t("add") }} </span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    isFlights: {
      type: Boolean,
      default: false
    },
    isCars: {
      type: Boolean,
      default: false
    },
    isTrains: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { firstName: "", lastName: "", emailAddress: "" };
  },
  methods: {
    createUnlistedEmployee() {
      const unlistedEmployee = {
        firstName: this.firstName,
        lastName: this.lastName,
        emailAddress: this.emailAddress,
        // Magic! (for removing)
        id: Math.floor(Math.random() * 99383)
      };
      this.firstName = "";
      this.lastName = "";
      this.emailAddress = "";
      this.track("hotelReservationGuestAdd", {
        additionType: "manual"
      });
      this.$emit("createdUnlistedEmployee", { employee: unlistedEmployee });
    }
  }
};
</script>

<style lang="scss" scoped></style>
